export const Images = {
  logo: require("../assets/logo.png"),
};
